/**
 * Account status colours, shared by the Users list (UserRow: icon and word) and the
 * "Filter by Account" dropdown bullets, so they always match (TW-346).
 *
 * Theme tokens that meet WCAG AA (4.5:1) in light and dark, on plain, hovered and
 * selected rows. The Tailwind -500 shades they replace did not.
 */
export const USER_STATUS_COLORS = {
  uninvited_member: 'text-meta',
  invited: 'text-status-info',
  invited_expired: 'text-status-warning',
  active: 'text-status-success',
  deactivated: 'text-status-danger',
} as const;
